import styled from 'styled-components';
import { ReactComponent as CustomerLayoutSvg } from 'assets/svgs/customer-layout.svg';
import { ReactComponent as VendorLayoutSvg } from 'assets/svgs/vendor-layout.svg';

interface LayoutSvgProps {
  brandColor: string;
  sideNavBg: string;
  sideNavText?: string;
}

export const VendorLayout = styled(VendorLayoutSvg)<LayoutSvgProps>`
  --brand-color: ${({ brandColor }) => brandColor};
  --side-nav-bg: ${({ sideNavBg }) => sideNavBg};
  --side-nav-text: ${({ sideNavText }) => sideNavText};
`;

export const CustomerLayout = styled(CustomerLayoutSvg)<LayoutSvgProps>`
  --brand-color: ${({ brandColor }) => brandColor};
  --side-nav-bg: ${({ sideNavBg }) => sideNavBg};
  --side-nav-text: ${({ sideNavText }) => sideNavText};
`;
